import { getBlobFile, getData, postData, postFile } from '@/lib/utils/api';
import {
  CreateTicketRequest,
  IAddTicketRequest,
  ICommentDetailFile,
  IFeedbackRequest,
  ITicketDetails,
  ITicketList,
  ITicketStatuses,
} from '@/models/support';
import { AxiosProgressEvent } from 'axios';

export const getTicketStatuses = (): Promise<ITicketStatuses[]> => {
  return getData(`support/tickets/statuses`, { version: 'v2' });
};

export const getTicketList = (
  FromDate?: string,
  PageNumber?: number,
  PageSize?: number,
  StatusId?: number | null,
  ToDate?: string
): Promise<ITicketList> => {
  return getData(
    `support/tickets?PageSize=${PageSize}&PageNumber=${PageNumber}&StatusId=${StatusId}&FromDate=${FromDate}&ToDate=${ToDate}`,
    { version: 'v2' }
  );
};
export const getTicketDetails = (
  ticketId: string,
  PageNumber: number,
  PageSize: number
): Promise<ITicketDetails[]> => {
  return getData(
    `support/tickets/${ticketId}/comments?PageSize=${PageSize}&PageNumber=${PageNumber}`,
    {
      version: 'v2',
    }
  );
};

export const postAddTicketComment = (
  ticketId: string,
  data: IAddTicketRequest
): Promise<number> => {
  return postData<IAddTicketRequest, number>(`support/tickets/${ticketId}/comments`, {
    data: data,
    version: 'v2',
  });
};

export const sendTicketAttachment = (
  file: File,
  onProgress?: (progressEvent: AxiosProgressEvent) => void,
  isComment?: boolean
) => {
  return postFile(`support/tickets/attachments`, file, {
    version: 'v2',
    onUploadProgress: onProgress,
    data: isComment !== undefined ? { isComment } : {},
  });
};

export const postCreateTicket = (data: CreateTicketRequest): Promise<void> => {
  return postData<CreateTicketRequest, void>(`support/tickets`, {
    data,
    version: 'v2',
  });
};

export const getCommentDetailFile = (
  ticketId: string,
  CommentId: number,
  AttachmentId: string,
  fallbackFileName?: string
): Promise<ICommentDetailFile> => {
  return getBlobFile(
    `support/tickets/${ticketId}/file?AttachmentId=${AttachmentId}&CommentId=${CommentId}`,
    { version: 'v2' }
  ).then(({ blob, fileName, contentType }) => ({
    blob,
    fileName: fileName === 'download' && fallbackFileName ? fallbackFileName : fileName,
    contentType,
  }));
};

export const sendFeedback = (data: IFeedbackRequest): Promise<void> => {
  return postData<IFeedbackRequest, void>(`support/feedback`, {
    data,
    version: 'v2',
  });
};
